export const MI_TO_KM = 1.60934;
export const KM_TO_MI = 1 / MI_TO_KM;

export function normalizeToKm(value: string, unit: 'km' | 'mi'): number | null {
  const n = Number(value.replace(',', '.'));
  if (Number.isNaN(n)) return null;
  return unit === 'mi' ? n * MI_TO_KM : n;
}

export function formatDistance(valueKm: number, unit: 'km' | 'mi'): string {
  const v = unit === 'mi' ? valueKm * KM_TO_MI : valueKm;
  return Number.isFinite(v) ? v.toFixed(1) : '';
}
